import {
  ActivatePage,
  ForgotPasswordPage,
  LoginPage,
  LoginWithTokenPage,
  PackageDetails,
  RegisterPage,
  SelectUserPage,
  SetPasswordPage,
  SetupTwoFaPage
} from 'modules/auth/pages'
import { DesktopRouter } from 'modules/desktop/DesktopRouter'
import { DownloadCenterRouter } from 'modules/download-center'
import { AuthCheckPage } from 'src/misc/pages'

export const APP_ROUTES = {
  authCheck: {
    path: '/auth-check',
    component: AuthCheckPage,
    isProtected: false,
    exact: true
  },
  loginWithToken: {
    path: '/login/withToken',
    component: LoginWithTokenPage,
    isProtected: false,
    exact: true
  },
  login: {
    path: '/login',
    component: LoginPage,
    isProtected: false,
    exact: true
  },
  register: {
    path: '/register',
    component: RegisterPage,
    isProtected: false,
    exact: true
  },
  userSelect: {
    path: '/user-select',
    component: SelectUserPage,
    isProtected: false,
    exact: true
  },
  forgotPassword: {
    path: '/forgot-password',
    component: ForgotPasswordPage,
    isProtected: false,
    exact: true
  },
  setPassword: {
    path: '/set-password',
    component: SetPasswordPage,
    isProtected: false,
    exact: true
  },
  activate: {
    path: '/activate',
    component: ActivatePage,
    isProtected: false,
    exact: true
  },
  packageDetails: {
    path: '/package-details',
    component: PackageDetails,
    isProtected: true,
    exact: true
  },
  setupTwoFa: {
    path: '/2fa-setup',
    component: SetupTwoFaPage,
    isProtected: true,
    exact: true
  },
  download: {
    path: '/download',
    component: DownloadCenterRouter,
    isProtected: true,
    exact: false
  },
  desktop: {
    path: '/',
    component: DesktopRouter,
    isProtected: true,
    exact: false
  }
}
